import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion-primitives";
import { SectionHead } from "@/components/shared";
import { IMAGES } from "@/lib/site";

const PLACEHOLDERS = ["Your property, showcased", "Your business, online"];

export default function PortfolioShowcase() {
  return (
    <section className="mt-24" data-testid="design-portfolio">
      <SectionHead
        overline="Design Portfolio"
        title="Recent work & current openings."
        copy="Our design practice is young and deliberate — every project gets senior attention. This is what we mean by the standard."
      />
      <div className="mt-12 grid gap-8 md:grid-cols-3">
        <Reveal>
          <div className="group border border-navy/10 bg-white">
            <div className="img-frame h-56 overflow-hidden">
              <img src={IMAGES.hero} alt="The Bermuda Co-Host website" className="h-full w-full object-cover" loading="lazy" />
            </div>
            <div className="p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-serif text-xl text-navy">The Bermuda Co-Host</h3>
                <span className="bg-ocean-light px-2.5 py-1 text-[9px] font-bold uppercase tracking-wider text-ocean">Live</span>
              </div>
              <p className="mt-2.5 text-[13px] leading-relaxed text-navy/60">
                Brand, design and build — the website you're reading right now. Coastal luxury aesthetic, lead-capture
                forms, owner portal and a full resource center.
              </p>
            </div>
          </div>
        </Reveal>
        {PLACEHOLDERS.map((label, i) => (
          <Reveal key={label} delay={0.08 + i * 0.08}>
            <div className="flex h-full flex-col border border-dashed border-navy/20 bg-sand-light/50">
              <div className="flex h-56 items-center justify-center">
                <span className="font-serif text-6xl font-light italic text-navy/15">BCH</span>
              </div>
              <div className="flex flex-1 flex-col p-7">
                <div className="flex items-center justify-between">
                  <h3 className="font-serif text-xl text-navy/50">{label}</h3>
                  <span className="bg-sand px-2.5 py-1 text-[9px] font-bold uppercase tracking-wider text-navy/50">Booking Now</span>
                </div>
                <p className="mt-2.5 flex-1 text-[13px] leading-relaxed text-navy/45">
                  We're currently taking on a small number of design projects. Yours could be here — launched,
                  photographed and booking.
                </p>
                <Link to="/consultation" data-testid={`portfolio-slot-${i}`} className="mt-5 flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-bermuda-dark hover:text-navy transition-colors">
                  Start the Conversation <ArrowUpRight size={13} />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
